import * as React from 'react';
import { navigate } from 'router';

import PageWrapper from '~/common/layout/PageWrapper';
import PageContent from '~/common/layout/PageContent';
import PageContentWrapper from '~/common/layout/PageContentWrapper';

import SideMenu from '../containers/common/SideMenu';
import OrgLocationHeader from '~/apps/shared/containers/locations/OrgLocationHeader';
import OrgLocationList from '~/apps/shared/containers/locations/OrgLocationList';


export default function (params, children = null) {
  return (
    <React.Fragment>
      <PageWrapper>
        <SideMenu />
        <PageContent>
          <OrgLocationHeader
            orgId={params.orgId}
            onCreate={() => {
              navigate('admin.orgs.locations.create', {orgId: params.orgId});
            }}
          />
          <PageContentWrapper>
            <OrgLocationList
              orgId={params.orgId}
              onEdit={(locationId) => {
                navigate('admin.orgs.locations.edit', {orgId: params.orgId, locationId});
              }}
            />
          </PageContentWrapper>
        </PageContent>
        {children}
      </PageWrapper>
    </React.Fragment>
  );
};
